import React from 'react'
import { Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import { APP_ROUTES } from '../../../common/constants'

import { useLoggedInUser } from '../../hooks'

const AuthRedirect = ({ children }) => {
  const user = useLoggedInUser()

  return user ? (
    children
  ) : (
    <Navigate to={APP_ROUTES.ACCOUNT.children.LOGIN.fullPath} replace />
  )
}

AuthRedirect.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AuthRedirect
